var exports = {
  "kL": "x61f99309--5c9c82--container",
  "Qs": "x61f99309--5c9c82--content",
  "wx": "x61f99309--5c9c82--header",
};

module.exports = exports;
